import { Component, OnInit } from '@angular/core';
import { CHANNEL } from 'src/app/shared/constants/channel.constants';
import {
  ChannelCommunicatorService,
} from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { RequestService } from 'src/app/shared/services/request/request-onboarding.service';

import { EVENT } from '../../../shared/constants/dali.constants';
import { OpEnum } from '../../../shared/enums/op.enum';
import { TagEvent } from '../../../shared/models/dali-tags.model';
import { LogDeviceModel } from '../../../shared/models/log-device.model';
import { IProductsModel } from '../../../shared/models/products.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from '../../../shared/services/bitacora/bitacora.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { HelpersService } from '../../../shared/services/helpers/helpers-onboarding.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { ProductsService } from '../../../shared/services/products/products.service';
import { TaggingService } from '../../../shared/services/tagging/tagging.service';
import { callbackAdjustSolicitarTC } from 'src/app/shared/constants/adjust-callback';
import Adjust from '@adjustcom/adjust-web-sdk';
import { PopupService } from 'src/app/shared/services/popup/popup.service';
import { IPopupState } from 'src/app/shared/interfaces/popup.interface';
import { FirmlyApprovedService } from '../../../shared/services/firmly-approved/firmly-approved.service';
import { SpecialOfferModel } from 'src/app/shared/models/specialOffer/special-offer.model';
import { IFirmlyApproved } from 'src/app/shared/interfaces/firmly-approved';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { ConfigurationService } from 'src/app/shared/services/configuration/configuration.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
/**
 * Configuración predeterminada del componente
 *
 * *Default component settings*
 */
@Component({
  selector: 'app-product-selection',
  templateUrl: './product-selection.component.html',
  styleUrls: ['./product-selection.component.scss'],
})

/**
 * Clase del componente para la selección de productos
 *
 * *Product selection class component*
 *
 * @implements {OnInit}
 */
export class ProductSelectionComponent implements OnInit {

  consultation_request = 'ConsultationRequest';

  /**
   * Declaración de la variable devicePrint como LogDeviceModel, se registra la información del dispositivo
   *
   * *Set devicePrint variable as LogDeviceModel, where device info is registered*
   *
   * @access              private
   * @type                {LogDeviceModel}
   */
  private devicePrint: LogDeviceModel;

  /**
   * Declaración de la variable products como IProductsModel, donde se guardan los productos
   *
   * *Set products variable as IProductsModel, where products list are saved*
   *
   * @access              public
   * @type                {IProductsModel[]}
   */
  products: IProductsModel[];

  /**
   * Filtro de productos a mostrar en las cards en el products
   */
  private productsList: IProductsModel[];

  /**
   * Listado de productos a mostrar en las cards u ocultar
   */
  private productsAcepted: any;

  /**
   * Indicador si el cliente ingreso por App y es CN
   */
  isNewClient: boolean;

  /**
   * Producto principal a mostrar para CN
   */
  principalProduct: IProductsModel;

  /**
   * Otras opciones a mostrar a un CN fuera de los
   * productos pasivos y activos.
   */
  otherOptions: IProductsModel[];

  /**
   * Declaración de la variable productSelected como IProductsModel, donde se registra el producto seleccionado por le usuario
   *
   * *Set productSelected variable as IProductsModel, where selected product is saved*
   *
   * @access              public
   * @type                {IProductsModel}
   */
  productSelected: IProductsModel;
  allies: any;
  channelId;
  isPostLogin: boolean;
  prodAdjust: boolean;
  isContinuingFlow: boolean;
  lastButtonClicked: string;
  buttonLabels: any;
  firmlyApprovedOffers: IFirmlyApproved[];
  hasFirmlyApprovedOffer: boolean;

  benefitsSavingAccount: any[];
  component: IProductsModel;
  isJemelli = false;

  private _subscriber$ = new Subject<void>();

  showHomeCredit = true;

  /**
   * Constructor of the component.
   *
   * @param {CopyService}   copyService   Injectable copyService service.
   * @param {NavigationService} navigationService Injectable navigationService service.
   * @param {AbreCuentasService}   abreCuentasService   Injectable abreCuentasService service.
   * @param {ParametersService} parametersService   Injectable parametersService service.
   * @param {BioCatchService}   biocatchService   Injectable copyService service.
   * @param {RequestService}   requestService   Injectable requestService service.
   * @param {HeaderService}     headerService     Injectable headerService service.
   * @function headerService.show() Hides header
   */
  constructor(
    public copyService: CopyService,
    public helper: HelpersService,
    private navigationService: NavigationService,
    private abreCuentasService: AbreCuentasService,
    private parametersService: ParametersService,
    private productsService: ProductsService,
    private headerService: HeaderService,
    private taggingService: TaggingService,
    private bitacoraService: BitacoraService,
    public channelCommunicatorService: ChannelCommunicatorService,
    private requestService: RequestService,
    private popupService: PopupService,
    private firmlyApprovedService: FirmlyApprovedService,
    private configurationService: ConfigurationService,
  ) {
    this.headerService.show(false, false, true);
    this.isContinuingFlow = false;
    this.hasFirmlyApprovedOffer = false;
    this.buttonLabels = {
      viewProducts: 'VerProductos',
      knowMore: 'ConoceMas',
    };
    this.productsAcepted = {};
    this.showHomeCredit = !this.abreCuentasService.getUserJemelii();
    this.isJemelli = this.abreCuentasService.getUserJemelii();
  }

  /**
   * Función de Angular ejecutada una vez el componente sea cargado, carga los productos a mostrar
   *
   * *Angular function that is run when the component is loaded, charges products to be displayed*
   */
  async ngOnInit() {
    // console.warn('Copies: ', this.copyService.copies.new_client);
    this.isNewClient = this.abreCuentasService.getIsNewClient();
    this.popupService.popupState.subscribe(async (resp: IPopupState) => {
      if (!resp.continueFlow) {
        return;
      }
      this.isContinuingFlow = true;
      if (this.lastButtonClicked === this.buttonLabels.viewProducts) {
        this.goAhead(this.productSelected);
      } else {
        this.goToProductDetails(this.productSelected, this.buttonLabels.knowMore);
      }
    }, error => {
      console.error('Error getting popup state:', error);
    });
    if (this.parametersService.getParameter('warningDisplay') &&
      (this.channelCommunicatorService.getChannelId() === '141' ||
        this.channelCommunicatorService.getChannelId() === '163' ||
        this.channelCommunicatorService.getChannelId() === '131' ||
        this.channelCommunicatorService.getChannelId() === '160')) {
      this.navigationService.navigateToGeneralInformation('999');
    }
    console.log('Product-selection ----------------->>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');
    this.abreCuentasService.setMultiView(false);
    this.productsList = this.abreCuentasService.getPostlogin() ?
      this.parametersService.getSetting(OpEnum.ABRE_CUENTAS_PRODUCTS_CE) : this.parametersService.getSetting(OpEnum.ABRE_CUENTAS_PRODUCTS);
    this.advance();
    const structure = await this.abreCuentasService.getFlowStructure();
    if (this.channelCommunicatorService.getChannelId() === '163') {
      this.checkAlly();
    } else if (this.isNewClient) {
      // this.benefitsSavingAccount = this.copyService.copies.new_client.saving_account.benefits;
      // console.log('beneficios: ', this.benefitsSavingAccount);
      this.listProductsAcepted(structure, true, true, true, true, false);
    } else {
      this.listProductsAcepted(structure);
      this.navigationService.pageLoadTag();
      this.isPostLogin = this.abreCuentasService.getPostlogin();
      this.channelId = this.channelCommunicatorService.getChannelId();
      if (this.channelId === CHANNEL.SUPERAPP.CODE) {
        setTimeout(() => {
          this.adjustInit();
        }, 1000);
      }
      return;
    }

  }

  private async listProductsAcepted(
    structure: any,
    multi: boolean = true,
    saving: boolean = true,
    payroll: boolean = true,
    living: boolean = true,
    consultationRequest: boolean = true) {
    this.productsAcepted[BUSINESS_CONST.MULTI] = multi;
    this.productsAcepted[BUSINESS_CONST.PRODUCT_TYPE_SAVINGS] = saving;
    this.productsAcepted[BUSINESS_CONST.PRODUCT_TYPE_PAYROLL] = payroll;
    this.productsAcepted[BUSINESS_CONST.PRODUCT_TYPE_LIVING] = living;
    this.productsAcepted[BUSINESS_CONST.PRODUCT_REQUEST_CONSULT] = consultationRequest;

    await this.selectionProducts(structure);
  }

  private async selectionProducts(structure: any) {
    // inner join products and structure
    this.productsList = this.productsList.filter((product: any) => structure[0].flows[product.flow] !== undefined);
    console.log('Listado de productos: ', this.productsList);
    if (this.isNewClient) {
      this.principalProduct = this.productsList.filter((product: any) => product.product_type === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS)[0];
      this.otherOptions = this.productsList.filter((product: any) => product.product_type === BUSINESS_CONST.PRODUCT_REQUEST_CONSULT);
    }

    this.listProductSelection();

  }

  private listProductSelection() {
    this.productsList = this.productsList.filter((product: any) =>
      (product.product_type === BUSINESS_CONST.MULTI && this.productsAcepted[BUSINESS_CONST.MULTI])
      || (product.product_type === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS && this.productsAcepted[BUSINESS_CONST.PRODUCT_TYPE_SAVINGS])
      || (product.product_type === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL && this.productsAcepted[BUSINESS_CONST.PRODUCT_TYPE_PAYROLL])
      || (product.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING && this.productsAcepted[BUSINESS_CONST.PRODUCT_TYPE_LIVING])
      || (product.product_type === BUSINESS_CONST.PRODUCT_REQUEST_CONSULT && this.productsAcepted[BUSINESS_CONST.PRODUCT_REQUEST_CONSULT]),
    );

    console.log('Products: ', this.productsList);
    this.evaluateProducts();
  }

  async checkAlly() {
    console.log('ajuste para cargar flow');
    await this.requestService.documentsAllies()
      .then(res => this.allies = res.Ally)
      .catch(err => console.log(err));
    const ally = this.allies.filter(item => item.code_Ally === this.abreCuentasService.getAllyCode());
    console.log('ally[0]  ', ally[0]);
    this.nextToProductDetails();
  }

  adjustInit() {
    this.prodAdjust = this.parametersService.getParameter('daliEnvProd');
    if (this.prodAdjust === true && this.isPostLogin === false) {
      Adjust.initSdk({
        appToken: this.parametersService.getSetting(OpEnum.ADJUST_APPTOKEN), // required
        environment: 'production', // required, 'production' or 'sandbox' in case you are testing SDK locally with your web app
        logLevel: 'none', // optional, default is 'error', other options are 'none', 'error', 'warning', 'info', 'verbose'
      });
    } else if (this.prodAdjust === false && this.isPostLogin === false) {
      Adjust.initSdk({
        appToken: this.parametersService.getSetting(OpEnum.ADJUST_APPTOKEN), // required
        environment: 'sandbox', // required, 'production' or 'sandbox' in case you are testing SDK locally with your web app
        logLevel: 'verbose', // optional, default is 'error', other options are 'none', 'error', 'warning', 'info', 'verbose'
      });
    }
    this.AdjustEvent();
  }

  AdjustEvent() {
    if (this.isPostLogin === false) {
      const event = {
        eventToken: 'kiix9r',
        callbackParams: callbackAdjustSolicitarTC,
      };
      this.channelId === CHANNEL.SUPERAPP.CODE ? Adjust.trackEvent(event) : Adjust.trackEvent(event);
    }
    return;
  }

  /**
   * Función para ir a los detalles del producto seleccionado
   *
   * *Go to selected product details function*
   *
   * @param {IProductsModel} product
   * @param {string} _label
   */
  async goToProductDetails(product: IProductsModel, _label: string) {
    this.lastButtonClicked = this.buttonLabels.knowMore;
    this.productSelected = product;
    if (!this.isContinuingFlow && this.productSelected.name === 'MultiProduct') {
      await this.validateFirmlyApprovedOffersForPopup();
    }
    if (!this.isContinuingFlow && this.hasFirmlyApprovedOffer) {
      this.popupService.showPopup();
      return;
    }
    this.abreCuentasService.setproductSelected(product);
    // this.configurationService.selectProductType(product);
    this.nextToProductDetails();
    const category = {
      module: 'body',
      type: 'link',
      position: 'bottom',
    };
    const productCamelize = this.navigationService.camelize(product.name);
    const CustomLabel = `${_label} | ${productCamelize}`;
    this.pageTagEvent('1', category, 'click', CustomLabel);
  }

  /**
   * Función para empezar la solicitud del producto seleccionado
   *
   * *Function that starts solicitation of the selected product*
   *
   * @param {IProductsModel} product
   */
  async goAhead(product: IProductsModel) {
    console.log('Continuando flujo normal');
    this.lastButtonClicked = this.buttonLabels.viewProducts;
    console.log('Product recibido: ', product);
    this.productSelected = product;
    const category = {
      module: 'body',
      type: 'image',
      position: 'bottom',
    };
    const CustomLabel = `Imagen | ${this.productSelected.name}`;
    this.pageTagEvent('2', category, 'click', CustomLabel);
    if (!this.isContinuingFlow && this.productSelected.name === 'MultiProduct') {
      await this.validateFirmlyApprovedOffersForPopup();
    }
    if (!this.isContinuingFlow && this.hasFirmlyApprovedOffer) {
      this.popupService.showPopup();
      return;
    }
    console.log('Producto seleccionado: ', this.productSelected);
    this.abreCuentasService.setproductSelected(this.productSelected);
    if (this.productSelected.name !== 'ConsultationRequest') {
      if (this.channelId === CHANNEL.PORTALO.CODE) {
        if (!this.abreCuentasService.getSellerMarca()) {
          const { seller_doc_num, seller_name } = this.abreCuentasService.getSeller();
          this.bitacoraService.saveDataInBitacora('Seller_ID_' + seller_doc_num);
          this.bitacoraService.saveDataInBitacora('Seller_Name_' + seller_name);
          this.abreCuentasService.setSellerMarca(true);
        }
      }
      this.configurationService.validateBiocatch(this.productSelected);
      /* this.bioCatchService
        .checkCountry(false)
        .then(response => {
          if (response.data.response || !this.bioCatchService.getGeoServiceComplete()) {
            this.selectProduct(this.productSelected, 'nextToSolicitation');
          } else {
            this.navigationService.navigateToGeneralInformation('dsbException');
          }
        }, error => {
          console.error('BiocatchError..');
          console.error(error);
          this.navigationService.navigateToGeneralInformation('500');
          if (!this.abreCuentasService.getPostlogin()) {
            this.navigationService.pageLoadTag(false, ['pv415', '', '', '']);
          }
        }).catch(() => this.navigationService.navigateToGeneralInformation('500')); */
    } else {
      this.configurationService.selectProductType(product);
    }
  }

  async validateFirmlyApprovedOffersForPopup() {
    const channelsAllowed = [
      CHANNEL.PORTALPN.CODE,
      CHANNEL.SUPERAPP.CODE,
    ];
    if (!this.abreCuentasService.getPostlogin() || !channelsAllowed.includes(this.channelId)) {
      return;
    }
    await this.firmlyApprovedService.getProductsOffer();
    this.firmlyApprovedOffers = this.firmlyApprovedService.getProductsFirmlyApproved();
    if (this.firmlyApprovedOffers && this.firmlyApprovedOffers.length > 0) {
      let offerData: SpecialOfferModel = {
        offerId: String(this.firmlyApprovedOffers[0].id),
        offerType: this.firmlyApprovedOffers[0].offerType,
      };
      this.firmlyApprovedService.setOffer_Channel(offerData);
      this.hasFirmlyApprovedOffer = true;
    }
  }

  /**
   * Función que guarda la información del producto seleccionado
   *
   * *Funtion that saves selected product infomation*
   *
   * @param {IProductsModel} product
   * @param {string} advance
   */
  advance() {
    this.configurationService.getProductIsReady().pipe(takeUntil(this._subscriber$)).subscribe(
      (isReady: boolean) => {
        if (isReady) {
          console.log('advance: ', this.abreCuentasService.getproductSelected().code);
          this.navigationService.nextStep(this.abreCuentasService.getproductSelected().code);
        }
      },
    );
  }

  /**
   * Función para ir a los detalles del producto seleccionado, se utiliza el código del producto
   *
   * *Function that goes to the selected product details, it uses the product code*
   */
  nextToProductDetails() {
    if (this.channelCommunicatorService.getChannelId() === '163') {
      const product_code = this.abreCuentasService.getproductSelected().product_code;
      switch (product_code) {
        case 'TCR':
          this.navigationService.nextStep('002');
          break;
      }
    } else {
      const code = this.abreCuentasService.getproductSelected().code;
      code === '205' ? this.navigationService.nextStep('207') :
        code === '209' ? this.navigationService.nextStep('219') :
          code === '211' ? this.navigationService.nextStep('221') :
            code === '951' ? this.navigationService.nextStep('955') :
              code === '999' ? this.navigationService.nextStep('998') :
                code === '023' ? this.navigationService.nextStep('033') :
                  code === '001' ? this.navigationService.nextStep('002') :
                    this.navigationService.nextStep();
    }
  }

  /**
   * Función para validar el estado de los productos
   *
   * *Function that validates products states*
   */
  private evaluateProducts() {
    const rules = {};
    console.warn('evaluateProducts: Products: ', this.productsList);
    this.productsList.forEach(product => {
      if (!product.visibility_rule && !rules[product.visibility_rule]) { return; }
      let parameters = {
        channel_id: this.abreCuentasService.getAppInfo().channelId,
        mobile_platform: this.abreCuentasService.getAppInfo().platform,
        app_version: this.abreCuentasService.getAppInfo().appVersion,
      };
      if (this.abreCuentasService.getIsPortal()) {
        parameters = this.parametersService.getSetting(OpEnum.BETA_PORTAL);
      }

      const rule = {
        rule_name: product.visibility_rule,
        parameters,
      };
      rules[product.visibility_rule] = rule;
    });

    const rulesRq = Object.keys(rules).map(key => rules[key]);
    if (rulesRq.length === 0) {
      this.products = this.productsList;
      return;
    }
    console.log('product-selection >>>> Rules: ', rulesRq);
    this.productsService.validateRules(rulesRq, this.productsList)
      .then(productsByRules => {
        this.products = productsByRules;
      })
      .catch(() => this.navigationService.navigateToGeneralInformation('500'));
  }

  pageTagEvent(eventNumber: string, category: any, customAction: string, customLabel?: string) {
    const tagPageName = this.navigationService.getCurrentStep().tag_name;
    const event: TagEvent = {
      category: {
        module: EVENT.customCategory.module[category.module],
        type: EVENT.customCategory.type[category.type],
        position: EVENT.customCategory.position[category.position],
      },
      action: EVENT.customAction[customAction],
      label: customLabel ? customLabel : EVENT[`${tagPageName}E${eventNumber}customLabel`],
    };

    this.taggingService.pageTagEvent(event);
  }

  nextNewClient() {
    console.log('llamamos al siguiente evento');
  }
}
